import React from "react";
import { useMessageSource } from "react-message-source";
import { ApplicationFlows } from "../../../route/application/authenticated/application-flow/types";
import GTM from "../../../util/tracking/gtm";
import {
  EventCategory,
  PERSON_ADDED_ACTION_VALUE,
} from "../../../util/tracking/types";
import MultiForm from "../../shared/components/multi-form";
import { emptyPerson } from "../defaults";
import Person from "../person";
import SameAsCardholderRadio from "../sameAsCardholderRadio";
import { SignatoryModel } from "../types";

export default function CustomSignatories({
  values,
  flowType,
}: {
  values: SignatoryModel;
  flowType: ApplicationFlows;
}): React.JSX.Element {
  const { getMessage } = useMessageSource();

  const { isSameAsCardholder, cardholderSignatories, otherSignatories } =
    values;

  const name =
    isSameAsCardholder === "yes" ? "cardholderSignatories" : "otherSignatories";
  const signatories =
    isSameAsCardholder === "yes" ? cardholderSignatories : otherSignatories;

  return (
    <div>
      <SameAsCardholderRadio
        isSameAsCardholder={isSameAsCardholder}
        flowType={flowType}
        {...cardholderSignatories[0]}
      />
      <MultiForm
        name={name}
        formData={signatories}
        addButtonText={getMessage("Signing.second-signatory-add")}
        removeButtonText={getMessage("Signing.second-signatory-remove")}
        createDefaultItemData={() => emptyPerson}
        renderFormComponent={(data, path) => (
          <Person {...data} dataPath={path} />
        )}
        limit={2}
        onAddItem={() => {
          GTM.trackEvent(
            EventCategory.AuthorizedSignatory,
            PERSON_ADDED_ACTION_VALUE,
          );
        }}
      />
    </div>
  );
}
